import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../partner/facilityInternalRequestReceive/ContextAPI';
import Index from '../partner/facilityInternalRequestReceive/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityInternalRequestPartnerReceive() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-internal-request-partner-receive'])
        return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
